<template>
    <div id="app">
        <HandleServerTime />

        <transition name="page-fade" mode="out-in">
            <site-header v-if="enableHeader" />
        </transition>

        <div class="site-content">
            <transition name="page-fade" mode="out-in">
                <router-view />
            </transition>
        </div>

        <transition name="page-fade" mode="out-in">
            <site-footer v-if="enableFooter" />
        </transition>

        <chat-helpdesk
            v-if="!chatNotAllowedInRoute && isChatEnabled"
        ></chat-helpdesk>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import screenfull from "screenfull";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatHelpdesk from "@/components/ChatHelpdesk";
import HandleServerTime from "@/components/HandleServerTime";
import eventHub from "@/event-hub";

export default {
    name: "Home",
    components: {
        "site-header": Header,
        "site-footer": Footer,
        ChatHelpdesk,
        HandleServerTime
    },
    computed: {
        ...mapState(["enableHeader", "enableFooter", "route"]),
        ...mapGetters(["isChatEnabled", "favicon"]),
        chatNotAllowedInRoute() {
            // TODO this should be part of the `isChatEnabled` logic but tyescript is being problematic
            const disableOnRoutes = ["Meeting"];

            return Boolean(disableOnRoutes.includes(this.route.name));
        }
    },
    created() {
        this.listenForEscape();
        this.handleOneSignal();

        if (this.favicon) {
            // TODO
            // Use SVG
            // https://css-tricks.com/svg-favicons-and-all-the-fun-things-we-can-do-with-them/
            // ... and we should really be using enviornment variables
            // this current setup is temporary and will likely break the favicon on some devices.
            document.querySelectorAll('link[rel="icon"]').forEach((item) => {
                if (this.favicon.includes(".svg")) {
                    item.type = "image/svg+xml";
                }
                item.href = `${process.env.BASE_URL}favicon/${this.favicon}`;
            });
        }

        if (screenfull.isEnabled) {
            screenfull.on("change", () => {
                this.setIsFullScreen();
            });
        }
    },
    methods: {
        ...mapMutations(["setIsFullScreen"]),
        listenForEscape() {
            const body = document.querySelector("body");
            body.onkeydown = function(e) {
                if (e.keyCode != 27) return;
                eventHub.$emit("key-pressed-escape");
            };
        },
        handleOneSignal() {
            if (window.OneSignal && "midsummer.fmi.org" === location.hostname) {
                window.OneSignal.push(function() {
                    window.OneSignal.init({
                        appId: "43b42ac4-7186-4e64-b682-7206f4584c10",
                        autoRegister: false,
                        notifyButton: {
                            enable: true,
                            position: "bottom-left",
                            prenotify: true,
                            showCredit: false,
                            colors: {
                                "circle.background": "var(--primary)",
                                "dialog.button.background.hovering":
                                    "var(--button-primary-hover)",
                                "dialog.button.background.active":
                                    "var(--accent)",
                                "dialog.button.background":
                                    "var(--button-primary)",
                                "dialog.button.foreground": "white"
                            }
                        },
                        welcomeNotification: {
                            title: "FMI Midsummer",
                            message: "Thank you for subscribing!"
                        }
                    });
                });
            }
        }
    }
};
</script>
